import {Component} from './component';

export class MarkdownEditor extends Component {

    setup() {
        this.elem = this.$el;

        this.pageId = this.$opts.pageId;
        this.textDirection = this.$opts.textDirection;
        this.imageUploadErrorText = this.$opts.imageUploadErrorText;
        this.serverUploadLimitText = this.$opts.serverUploadLimitText;

        this.display = this.$refs.display;
        this.input = this.$refs.input;
        this.displayWrap = this.$refs.displayWrap;

        const {settingContainer} = this.$refs;
        const settingInputs = settingContainer.querySelectorAll('input[type="checkbox"]');

        this.editor = null;
        window.importVersioned('markdown').then(markdown => {
            return markdown.init({
                pageId: this.pageId,
                container: this.elem,
                displayEl: this.display,
                inputEl: this.input,
                drawioUrl: this.getDrawioUrl(),
                settingInputs: Array.from(settingInputs),
                text: {
                    serverUploadLimit: this.serverUploadLimitText,
                    imageUploadError: this.imageUploadErrorText,
                },
            });
        }).then(editor => {
            this.editor = editor;
            this.setupListeners();
            this.emitEditorEvents();
            this.scrollToTextIfNeeded();
            this.editor.actions.updateAndRender();
            
            // Iniciar em modo Preview por padrão
            this.showPreviewMode();
        });
    }

    emitEditorEvents() {
        window.$events.emitPublic(this.elem, 'editor-markdown::setup', {
            markdownIt: this.editor.markdown.getRenderer(),
            displayEl: this.display,
            cmEditorView: this.editor.cm,
        });
    }

    setupListeners() {
        // Button actions
        this.elem.addEventListener('click', event => {
            const button = event.target.closest('button[data-action]');
            if (button === null) return;

            const action = button.getAttribute('data-action');
            if (action === 'insertImage') this.editor.actions.showImageInsert();
            if (action === 'insertLink') this.editor.actions.showLinkSelector();
            if (action === 'insertDrawing' && (event.ctrlKey || event.metaKey)) {
                this.editor.actions.showImageManager();
                return;
            }
            if (action === 'insertDrawing') this.editor.actions.startDrawing();
            if (action === 'fullscreen') this.editor.actions.fullScreen();
            
            // Toggle Editor/Preview
            if (action === 'showEditor') this.showEditorMode();
            if (action === 'showPreview') this.showPreviewMode();
        });

        // Mobile section toggling (legacy, but kept for compatibility)
        this.elem.addEventListener('click', event => {
            const toolbarLabel = event.target.closest('.editor-toolbar-label');
            if (!toolbarLabel) return;

            const currentActiveSections = this.elem.querySelectorAll('.markdown-editor-wrap');
            for (const activeElem of currentActiveSections) {
                activeElem.classList.remove('active');
            }

            toolbarLabel.closest('.markdown-editor-wrap').classList.add('active');
        });

        // handleDividerDrag removed - split screen disabled
    }
    
    showEditorMode() {
        const editorWrap = this.elem.querySelector('.markdown-editor-wrap:nth-child(2)');
        const previewWrap = this.displayWrap;
        const toggleButtons = this.elem.querySelectorAll('button[data-action="showEditor"], button[data-action="showPreview"]');
        
        editorWrap.classList.add('active');
        editorWrap.style.display = '';
        previewWrap.classList.remove('active');
        previewWrap.style.display = 'none';
        
        toggleButtons.forEach(btn => {
            if (btn.getAttribute('data-action') === 'showEditor') {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        });
    }
    
    showPreviewMode() {
        const editorWrap = this.elem.querySelector('.markdown-editor-wrap:nth-child(2)');
        const previewWrap = this.displayWrap;
        const toggleButtons = this.elem.querySelectorAll('button[data-action="showEditor"], button[data-action="showPreview"]');
        
        editorWrap.classList.remove('active');
        editorWrap.style.display = 'none';
        previewWrap.classList.add('active');
        previewWrap.style.display = '';
        
        // Update preview before showing
        if (this.editor) {
            this.editor.actions.updateAndRender();
        }
        
        toggleButtons.forEach(btn => {
            if (btn.getAttribute('data-action') === 'showPreview') {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        });
    }

    // handleDividerDrag method removed - split screen feature disabled

    scrollToTextIfNeeded() {
        const queryParams = (new URL(window.location)).searchParams;
        const scrollText = queryParams.get('content-text');
        if (scrollText) {
            this.editor.actions.scrollToText(scrollText);
        }
    }

    /**
     * Get the URL for the configured drawio instance.
     * @returns {String}
     */
    getDrawioUrl() {
        const drawioAttrEl = document.querySelector('[drawio-url]');
        if (!drawioAttrEl) {
            return '';
        }

        return drawioAttrEl.getAttribute('drawio-url') || '';
    }

    /**
     * Get the content of this editor.
     * Used by the parent page editor component.
     * @return {Promise<{html: String, markdown: String}>}
     */
    async getContent() {
        return this.editor.actions.getContent();
    }

}
